export default "__VITE_ASSET__CNZKyNTo__"